import { ReloadIcon } from '@hugeicons-pro/core-solid-rounded';
import React from 'react';
import { ActivityIndicator, Platform } from 'react-native';

import { Box } from '@/components/gluestack/box';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';

interface IHeaderRefreshButtonProps {
  isVisible?: boolean;
  isLargeScreen: boolean;
  isRefreshing?: boolean;
  isDisabled?: boolean;
  inAppHeaderBar?: boolean;
  onPress: () => void;
}

export function HeaderRefreshButton({
  isVisible = true,
  isLargeScreen,
  isRefreshing = false,
  isDisabled = false,
  inAppHeaderBar = false,
  onPress,
}: IHeaderRefreshButtonProps) {
  if (!isVisible || Platform.OS !== 'web') return null;

  if (isRefreshing) {
    return (
      <Box className="h-9 w-9 items-center justify-center">
        <ActivityIndicator color={inAppHeaderBar ? 'white' : 'grey'} />
      </Box>
    );
  }

  return (
    <ButtonWrapper
      icon={ReloadIcon}
      size="sm"
      inAppHeaderBar={inAppHeaderBar}
      onPress={onPress}
      isDisabled={isDisabled || isRefreshing}
    />
  );
}
